import * as moment from 'moment';
import NotificationService from '../../services/admin/NotificationService';

class UserNotificationHelper {
    getUrl(userNotification) {
        switch (userNotification.notification.notificationName) {
            case 'App.NewUserRegistered':
                return (
                    '/app/admin/users?filterText=' +
                    userNotification.notification.data.properties.emailAddress
                );
            case 'App.NewTenantRegistered':
                return (
                    '/app/admin/tenants?filterText=' +
                    userNotification.notification.data.properties.tenancyName
                );
                // Add your custom notification names to navigate to a URL when user clicks to a notification.
        }

        // No url for this notification
        return '';
    }

    /* PUBLIC functions ******************************************/

    getUiIconBySeverity(severity) {
        switch (severity) {
            case cf.notifications.severity.SUCCESS:
                return 'fa fa-check';
            case cf.notifications.severity.WARN:
                return 'fa fa-warning';
            case cf.notifications.severity.ERROR:
                return 'fa fa-bolt';
            case cf.notifications.severity.FATAL:
                return 'fa fa-bomb';
            case cf.notifications.severity.INFO:
            default:
                return 'fa fa-info';
        }
    }

    format(userNotification, truncateText) {
        let formatted = {
            userNotificationId: userNotification.id,
            text: cf.notifications.getFormattedMessageFromUserNotification(
                userNotification
            ),
            time: moment(userNotification.notification.creationTime).format(
                'YYYY-MM-DD HH:mm:ss'
            ),
            creationTime: userNotification.notification.creationTime,
            icon: this.getUiIconBySeverity(
                userNotification.notification.severity
            ),
            state: cf.notifications.getUserNotificationStateAsString(
                userNotification.state
            ),
            data: userNotification.notification.data,
            url: this.getUrl(userNotification),
            isUnread: userNotification.state ===
                cf.notifications.userNotificationState.UNREAD
        };

        if (truncateText || truncateText === undefined) {
            formatted.text = cf.utils.truncateStringWithPostfix(
                formatted.text,
                100
            );
        }
        
        return formatted;
    }

    show(userNotification) {
        // Application notification
        cf.notifications.showUiNotifyForUserNotification(userNotification, {
            onclick: () => {
                // Take action when user clicks to live toastr notification
                let url = this.getUrl(userNotification);
                if (url) {
                    location.href = url;
                }
            }
        });


    }

    async setAllAsRead(callback) {
        await NotificationService.setAllNotificationsAsRead();
        cf.event.trigger('app.notifications.refresh');
        if (callback) {
            callback();
        }
    }

    async setAsRead(userNotificationId, callback) {
        const input = {};
        input.id = userNotificationId;
        await NotificationService.setNotificationAsRead(input);
        cf.event.trigger('app.notifications.read', userNotificationId);
        if (callback) {
            callback(userNotificationId);
        }
    }
}

export default new UserNotificationHelper();